/** 发版后换新入口：预取 + 带 cache-bust 的导航，减少仍吃到旧 index 的概率。 */

export const stripReleaseCacheBustParam = () => {
	try {
		const url = new URL(window.location.href);
		if (!url.searchParams.has('_r')) return;
		url.searchParams.delete('_r');
		const next = `${url.pathname}${url.search}${url.hash}`;
		window.history.replaceState(null, '', next);
	} catch {
		/* ignore */
	}
};

/** 预取新版 index 引用的 JS/CSS；成功后再提示用户刷新（失败仍可硬刷新）。 */
export const prefetchNewStaticAssets = async () => {
	try {
		const htmlRes = await fetch(`/?_release=${Date.now()}`, {
			credentials: 'same-origin',
			cache: 'no-store',
			headers: { Accept: 'text/html' },
		});
		if (!htmlRes.ok) return false;
		const html = await htmlRes.text();
		const doc = new DOMParser().parseFromString(html, 'text/html');
		const urls = [
			...Array.from(doc.querySelectorAll('script[src]')).map((el) => el.getAttribute('src')),
			...Array.from(doc.querySelectorAll('link[rel="stylesheet"]')).map((el) => el.getAttribute('href')),
		].filter(Boolean);

		await Promise.all(
			urls.map((url) =>
				fetch(url, { credentials: 'same-origin', cache: 'force-cache' })
					.then((res) => (res.ok ? res.blob() : null))
					.catch(() => null),
			),
		);
		return true;
	} catch {
		return false;
	}
};

/** 预取新静态资源后，用带 _r 的 replace 强制拉新 index（比普通 reload 更不易卡旧包）。 */
export const navigateToLatestRelease = async () => {
	await prefetchNewStaticAssets();
	const url = new URL(window.location.href);
	url.searchParams.set('_r', String(Date.now()));
	window.location.replace(url.href);
};
